import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_PREFIX, resolveUrl } from 'src/core/constants/api.constants';
import { UiColorThemeDto } from 'src/core/models/theme/ui-color-theme.dto';

const UI_SETTINGS = `${API_PREFIX}/ui-settings`;

/**
 * Persists the user scoped interface preferences offered in the General Settings panel.
 *
 * There is no reader counterpart on purpose: the settings are registered as visible to clients, so the
 * effective values already reach the browser through ABP's application configuration.
 */
@Injectable({ providedIn: 'root' })
export class UiSettingsService {
  private readonly http = inject(HttpClient);
  updateColorTheme(input: UiColorThemeDto): Observable<void> {
    return this.http.put<void>(resolveUrl(`${UI_SETTINGS}/color-theme`), input);
  }
}
